const ExternalLinkIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 21) / 20}
        viewBox='0 0 20 21'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.16699 6.16667C3.94598 6.16667 3.73402 6.25446 3.57774 6.41074C3.42146 6.56702 3.33366 6.77899 3.33366 7V16.1667C3.33366 16.3877 3.42146 16.5996 3.57774 16.7559C3.73402 16.9122 3.94598 17 4.16699 17H13.3337C13.5547 17 13.7666 16.9122 13.9229 16.7559C14.0792 16.5996 14.167 16.3877 14.167 16.1667V11.1667C14.167 10.7064 14.5401 10.3333 15.0003 10.3333C15.4606 10.3333 15.8337 10.7064 15.8337 11.1667V16.1667C15.8337 16.8297 15.5703 17.4656 15.1014 17.9344C14.6326 18.4033 13.9967 18.6667 13.3337 18.6667H4.16699C3.50395 18.6667 2.86807 18.4033 2.39923 17.9344C1.93038 17.4656 1.66699 16.8297 1.66699 16.1667V7C1.66699 6.33696 1.93038 5.70107 2.39923 5.23223C2.86807 4.76339 3.50395 4.5 4.16699 4.5H9.16699C9.62723 4.5 10.0003 4.8731 10.0003 5.33333C10.0003 5.79357 9.62723 6.16667 9.16699 6.16667H4.16699Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.667 2.83333C11.667 2.3731 12.0401 2 12.5003 2H17.5003C17.9606 2 18.3337 2.3731 18.3337 2.83333V7.83333C18.3337 8.29357 17.9606 8.66667 17.5003 8.66667C17.0401 8.66667 16.667 8.29357 16.667 7.83333V3.66667H12.5003C12.0401 3.66667 11.667 3.29357 11.667 2.83333Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.0893 2.24408C18.4147 2.56951 18.4147 3.09715 18.0893 3.42259L8.92259 12.5893C8.59715 12.9147 8.06951 12.9147 7.74408 12.5893C7.41864 12.2638 7.41864 11.7362 7.74408 11.4107L16.9107 2.24408C17.2362 1.91864 17.7638 1.91864 18.0893 2.24408Z'
        />
      </svg>
    </span>
  );
};

export default ExternalLinkIcon;
